// extracted by mini-css-extract-plugin
export var changeIcon = "_4m-4";
export var container = "_4m-0";
export var divider = "_4m-7";
export var externalLinkIcon = "_4m-1";
export var green = "_4m-5";
export var helpCircleIcon = "_4m-3";
export var iconButton = "_4m-2";
export var red = "_4m-6";